// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tS-z","hovered":"uS-z","hoverImage":"vS-z","mainImage":"wS-z","imageNoBackground":"xS-z","fullSizeImage":"yS-z"};